import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLoadMeshes = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.99554499999999,
			d: "m511.993 63.994 387.973 223.99v448.002L511.993 959.987l-387.983-224V287.983z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "m256.01 385.46 253.81-320.2M256.01 385.46 130.45 284.29M514.19 65.26 769.21 384l124.35-99.71M128.01 738.29l384 29.71v192M899.98 736l-387.97 32M769.21 385.46 899.98 736M256.01 385.46l-128 352.83M769.21 384l-513.2 1.46 253.81 382.37z"
		})
	]
});
export default SvgIconLoadMeshes;
